import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-auth-header',
  templateUrl: './auth-header.component.html',
  styleUrls: ['./auth-header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthHeaderComponent {

}
